import hgpImage from './main';

export default {
  install(Vue) {
    Vue.component(hgpImage.name, hgpImage);
  },
};

